import { MatchupOutcome } from '@pff-consumer/schema/fantasy-league-sync/third-party'

const DEFAULT_OUTCOME = { wins: 0, losses: 0, ties: 0 }

export function getDraftersHistory(settings?: MatchupOutcome) {
  const { wins, losses, ties } = settings || DEFAULT_OUTCOME
  return ties ? `${wins}-${ties}-${losses}` : `${wins}-${losses}`
}
